import { Box } from '@mui/material';
import React, { useEffect } from 'react';
import { useCurrentDossierCtx, useDossierCustomHeader } from '@europrocurement/l2d-modules';
import { useFullLayout } from '@europrocurement/flexy-components';
import DetailDossierLeftNavBar from '../DetailDossierLeftNavBar/DetailDossierLeftNavBar';
import DossierBody from '../DossierBody/DossierBody';

const DetailDossierContainer: React.FunctionComponent = function () {
    const { setProfileHeaderVisible } = useFullLayout();
    const { dossier } = useCurrentDossierCtx();
    const { setIsDossierDetailPath, setHeaderTitle } = useDossierCustomHeader();

    // Update custom Header data, the actions will be set in the DetailDossierLeftNavBar
    useEffect(() => {
        if (dossier) {
            setIsDossierDetailPath(true);
            setProfileHeaderVisible(false);
            setHeaderTitle(`Dossier #${dossier?.numero} `);
        }
        return () => {
            setIsDossierDetailPath(false);
            setProfileHeaderVisible(true);
        };
    }, [dossier, dossier?.numero, setHeaderTitle, setIsDossierDetailPath, setProfileHeaderVisible]);

    return (
        <Box
            sx={{
                display: 'flex',
                width: '100%',
                height: 'calc(100vh - 112px)',
                overflow: 'hidden',
            }}
        >
            <Box sx={{ width: '25%', height: '100%', flexShrink: 0, overflowY: 'hidden' }}>
                <DetailDossierLeftNavBar sx={{ width: '100%' }} />
            </Box>

            <Box
                sx={{ flex: 1, height: '100%', paddingLeft: '8px', overflowY: 'auto', minWidth: 0 }}
            >
                <DossierBody />
            </Box>
        </Box>
    );
};

export default DetailDossierContainer;
